import { WippyErrorElement } from './wippy-error'
import { WippyLoadingElement } from './wippy-loading'

export { WippyErrorElement, WippyLoadingElement }

export function register() {
  if (!customElements.get('wippy-loading'))
    customElements.define('wippy-loading', WippyLoadingElement)
  if (!customElements.get('wippy-error'))
    customElements.define('wippy-error', WippyErrorElement)
}

// Auto-register when loaded as a script
register()
